import {get} from '@github/webauthn-json';
import {useEffect, useState} from 'react';
import {useLocation} from 'react-router';
import {
  handleUserAuthenticated,
  handleUserAuthenticationFailed,
  handleUserAuthenticationStarted
} from '../script/user-service';
import {
  finishAuthentication,
  startAuthentication
} from '../script/webauthn-service';

// eslint-disable-next-line require-jsdoc, max-lines-per-function
function AuthFrameLogin() {
  const [userName, setUserName] = useState(null);
  const location = useLocation();

  const hasAllowCredentials = (context) => {
    const allowCredentials = context?.allowCredentials;
    return allowCredentials && allowCredentials.length > 0;
  };

  // eslint-disable-next-line require-jsdoc
  const deleteInvalidTransports = (context) => {
    context.allowCredentials.map((item) => {
      if (item.transports === null) {
        delete item.transports;
      }
    });
  };

  // eslint-disable-next-line require-jsdoc
  const handleAuthentication = async () => {
    if (!userName) {
      return;
    }

    try {
      const context = await startAuthentication(userName);
      console.log('Received authentication context', context);
      const error = context.error;
      if (error) {
        handleUserAuthenticationFailed(userName, context);
        return;
      }

      if (hasAllowCredentials(context)) {
        deleteInvalidTransports(context);
      } else {
        handleUserAuthenticationFailed(
          userName,
          new Error('no credentials found')
        );
        return;
      }

      await handleUserAuthenticationStarted();
      const credential = await get({publicKey: context});

      await finishAuthentication(userName, credential);
      await handleUserAuthenticated(userName);
    } catch (error) {
      console.error(error);
      handleUserAuthenticationFailed(userName, error);
    }
  };

  // Update state variable userName whenever the corresponding query parameter changes:
  useEffect(() => {
    const param = new URLSearchParams(location.search).get('user-name');
    if (param && (!userName || userName !== param)) {
      setUserName(param);
    }
  }, [location]);

  // Authenticate whenever userName changes:
  useEffect(() => {
    handleAuthentication();
  }, [userName]);
  return null;
}

export default AuthFrameLogin;
